import { isEmpty } from 'lodash';
import {
  stringify,
  ParsedQuery as PermissionSetQueryParams,
} from 'query-string';
import { HttpClient } from 'api/http-client';
import { EntityAccessResponseMap } from 'contexts/permissions';
import { InitWorkerApi, InitWorkerRequestType } from 'initWorker';
import {
  CreateCustomPermissionSetPayload,
  PermissionSetDefinition,
  PermissionSetDefinitionsLight,
  RbacPageSource,
  UpdatePermissionSetPayload,
} from './rbac-types';

class RbacHttpClient extends HttpClient {
  public getPermissionSetDefinitions = async (
    queryParams: PermissionSetQueryParams = {},
  ): Promise<Array<PermissionSetDefinition>> => {
    let data: Array<PermissionSetDefinition>;

    if (isEmpty(queryParams)) {
      return this.get<Array<PermissionSetDefinition>>(
        '/permission-set/get-definition',
      );
    }

    const makeManualCall = async () => {
      return this.get<Array<PermissionSetDefinition>>(
        `/permission-set/get-definition?${stringify(queryParams)}`,
      );
    };

    if (process.env.NODE_ENV === 'test') {
      data = await makeManualCall();

      return data;
    }

    try {
      data = (await InitWorkerApi.getData(
        InitWorkerRequestType.PermissionSetDefinitions,
      )) as Array<PermissionSetDefinition>;
    } catch {
      data = await makeManualCall();
    }

    return data;
  };

  public getPermissionSetDefinitionsLight = async (): Promise<
    Array<PermissionSetDefinitionsLight>
  > => {
    return this.get<Array<PermissionSetDefinitionsLight>>(
      '/permission-set/get-definition-light',
    );
  };

  public createCustomPermissionSet = async (
    data: CreateCustomPermissionSetPayload,
  ): Promise<Array<PermissionSetDefinition>> => {
    return this.post('/permission-set/custom-permission-set', data);
  };

  public updatePermissionSet = async (
    data: UpdatePermissionSetPayload | UpdatePermissionSetPayload[],
  ): Promise<any> => this.put('/permission-set/custom-permission-set', data);

  public getEntityAccess = async (
    entityIds: number[],
    pageSource: RbacPageSource,
  ): Promise<EntityAccessResponseMap> =>
    this.post('/permissions/entity-access', {
      entityIds,
      rbacPageSource: pageSource,
    });
}

export const RbacApi = new RbacHttpClient();
